import { Box, Button, Tooltip } from "@mui/material"

const SmallButton = ({
    children,
    IconStart = false,
    IconEnd = false,
    height = "20px",
    title = "",
    active = false,
    ...rest
}) => {
    return (
        <Tooltip title={title} placement="bottom" arrow>
            <Box>
                <Button sx={{
                    height,
                    borderRadius: '4px',
                    border: (active ? "3px solid white" : "1px solid white"),
                    padding: (rest.size != "small" ? '5px 2px' : '2px 2px'),
                    '&.Mui-disabled': {
                        border: "2px solid rgba(239, 239, 239, 0.3)",
                        color: "rgba(239, 239, 239, 0.3)"
                    },
                    minWidth: "32px"
                }}
                cursor="pointer"
                {...rest}>
                    {IconStart && <IconStart sx={{ fontSize: '15px', color: 'white' }}/>}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 0px', fontSize: '10px', color: 'white' }}>{children}</div>
                    {IconEnd && <IconEnd/>}
                </Button>
            </Box>
        </Tooltip>
    )
}

export default SmallButton
